import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DispatcherService, ToastrTranslateService } from 'src/app/_services';
import { ComfirmDialogComponent } from '../../../trucks/edit-delete-truck/comfirm-dialog/comfirm-dialog.component';

@Component({
  selector: 'app-comfirm-dialog-dispatcher',
  templateUrl: './comfirm-dialog-dispatcher.component.html',
  styleUrls: ['./comfirm-dialog-dispatcher.component.scss'],
})
export class ComfirmDialogDispatcherComponent implements OnInit {
  constructor(
    private dispatcherService: DispatcherService,
    private dialogRef: MatDialogRef<ComfirmDialogComponent>,
    private toastrTranslateService: ToastrTranslateService,
    @Inject(MAT_DIALOG_DATA) private dispatcherId: number
  ) {}

  ngOnInit(): void {}

  deleteDispatcher() {
    this.dispatcherService.deleteDispatcher(this.dispatcherId).subscribe({
      next: (response) => {
        if (response.success) {
          this.toastrTranslateService.success('CONFIRM_DIALOG.SUCCESS_DELL');
          this.dialogRef.close({ success: response.success });
        } else {
          this.toastrTranslateService.error(
            response.message,
            'CONFIRM_DIALOG.FAILED_DELL'
          );
        }
      },
      error: (response) => {
        this.toastrTranslateService.error(
          response,
          'CONFIRM_DIALOG.FAILED_DELL'
        );
      },
    });
  }
}
